import React, { useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, OTP } from '../common';
import { useAuth } from '../../contexts/AuthContext';
import { MdEast } from 'react-icons/md';
import type { ApiResponse } from '../../utils';

interface ForgotPasswordVerificationFormData {
  otp: string;
}

const ForgotPasswordVerificationForm = () => {
  const [userEmail] = useState(localStorage.getItem('user-email') || '');
  const [isLoading, setIsLoading] = useState(false);

  const { verifyResetPassword } = useAuth();
  const {
    control,
    watch,
    setError,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordVerificationFormData>({
    defaultValues: {
      otp: '',
    },
  });

  const disabledSubmit = watch('otp').length !== 4;

  const onSubmit = async (data: ForgotPasswordVerificationFormData) => {
    setIsLoading(true);
    try {
      await verifyResetPassword({
        email: userEmail,
        code: data.otp,
      });
    } catch (error) {
      setError('otp', { message: (error as ApiResponse)?.message as string });
      console.error('Email verification failed:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <form className='w-full' onSubmit={handleSubmit(onSubmit)}>
      <div className='mb-6'>
        <Controller
          control={control}
          name='otp'
          rules={{
            required: { value: true, message: 'Please enter the OTP code' },
          }}
          render={({ field }) => (
            <OTP
              inputWrapperclassName='!justify-between'
              length={4}
              value={field.value}
              onChange={field.onChange}
              size='xl'
              separator={true}
              autoFocus={true}
              color={errors.otp?.message ? 'error' : 'default'}
              helperText={errors.otp?.message as string}
              helperTextClassName='text-red-500'
            />
          )}
        />
      </div>

      <Button
        type='submit'
        disabled={disabledSubmit}
        isLoading={isLoading}
        className='group relative w-full'
      >
        Verify <MdEast size={24} />
      </Button>
    </form>
  );
};

export default ForgotPasswordVerificationForm;
